export type ProductArgs = {
  code: string;
  amount: number;
  paid: number;
  earned: number;
  point: number;
  limitedPoint: number;
};

export class Product {
  code: string;
  amount: number;
  paid: number;
  earned: number;
  point: number;
  limitedPoint: number;

  constructor(l: ProductArgs) {
    this.code = l.code;
    this.amount = l.amount;
    this.paid = l.paid;
    this.earned = l.earned;
    this.point = l.point;
    this.limitedPoint = l.limitedPoint;
  }
}